import { Component, OnInit, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GalleryService } from '../_services/gallery.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit, OnDestroy {
  // Slideshow properties
  currentSlide: number = 0;
  slideInterval: any;
  totalSlides: number = 9;

  // Image Modal properties
  modalDisplay: string = 'none';
  modalImageSrc: string = '';

  // Video Modal properties
  videoModal1Display: string = 'none';
  videoModal2Display: string = 'none';
  videoModal1Src: SafeResourceUrl = '';
  videoModal2Src: SafeResourceUrl = '';
  videoModal1Type: 'iframe' | 'mp4' = 'iframe';
  videoModal2Type: 'iframe' | 'mp4' = 'iframe';

   currentPage: number = 0;
    itemsPerPage: number = 4;
    totalClients: number = 0;

    ngAfterViewInit(): void {
        this.updateTotalClients();
    }

  // Categories data for events gallery (placeholder - you can populate this with actual data from backend)
  categories: any[] = [

  ];

  constructor(private sanitizer: DomSanitizer,
     private route: ActivatedRoute,
      private router: Router,
    private elementRef: ElementRef, 
    private cdr: ChangeDetectorRef,
    private galleryService: GalleryService) { }

  ngOnInit() {

    this.loadEvents();
    // Initialize first slide
    this.currentSlide = 0;

    // Start slideshow auto-rotation
    this.startSlideshow();

    // Listen for ESC key to close modals
    document.addEventListener('keyup', this.handleEscKey.bind(this));

    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      const fragment = this.route.snapshot.fragment;

      if (fragment) {
        const element = document.getElementById(fragment);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });

    this.route.fragment.subscribe(fragment => {
      if (!fragment) return;

      // Ensure DOM is fully rendered
      setTimeout(() => {
        const element = document.getElementById(fragment);

        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 0);
    });

  }

  ngOnDestroy() {
    // Clean up slideshow interval
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
    // Remove event listener
    document.removeEventListener('keyup', this.handleEscKey.bind(this));
  }

  // Slideshow functions
  startSlideshow() {
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 5000); // Change slide every 5 seconds
  }

  nextSlide() {
    this.currentSlide++;
    if (this.currentSlide >= this.totalSlides) {
      this.currentSlide = 0;
    }
  }

  previousSlide() {
    this.currentSlide--;
    if (this.currentSlide < 0) {
      this.currentSlide = this.totalSlides - 1;
    }
  }

  // Image Modal functions
  openModal(imageSrc: string) {
    this.modalImageSrc = imageSrc;
    this.modalDisplay = 'block';
  }

  closeModal() {
    this.modalDisplay = 'none';
    this.modalImageSrc = '';
  }

  // Video Modal functions
  openVideoModal(videoUrl: string, modalId: string) {
    let safeUrl;
    let type: 'iframe' | 'mp4' = 'iframe';

    if (videoUrl.includes('.mp4')) {
      safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
      type = 'mp4';
    } else {
      const autoplayUrl = videoUrl + '?autoplay=1';
      safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(autoplayUrl);
      type = 'iframe';
    }

    if (modalId === 'videoModal1') {
      this.videoModal1Src = safeUrl;
      this.videoModal1Type = type;
      this.videoModal1Display = 'block';
    } else if (modalId === 'videoModal2') {
      this.videoModal2Src = safeUrl;
      this.videoModal2Type = type;
      this.videoModal2Display = 'block';
    }
  }

  closeVideoModal(modalId: string) {
    if (modalId === 'videoModal1') {
      this.videoModal1Display = 'none';
      this.videoModal1Src = '';
    } else if (modalId === 'videoModal2') {
      this.videoModal2Display = 'none';
      this.videoModal2Src = '';
    }
  }

  // Handle ESC key press
  handleEscKey(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.closeModal();
      this.closeVideoModal('videoModal1');
      this.closeVideoModal('videoModal2');
    }
  }


    // currentPage: number = 0;
    // itemsPerPage: number = 4;
    // totalPages: number = 3; // Since you have ~12 clients, adjust this based on your total

    // // Method to change the current page
    // goToPage(pageIndex: number): void {
    //     console.log('Going to page:', pageIndex);
    //     this.currentPage = pageIndex;
    // }

    // // Method to check if a client should be visible
    // isVisible(index: number): boolean {
    //     const startIndex = this.currentPage * this.itemsPerPage;
    //     const endIndex = startIndex + this.itemsPerPage;
    //     const visible = index >= startIndex && index < endIndex;
    //     return visible;
    // }

    // // Generate array for pagination dots
    // get pages(): number[] {
    //     return Array.from({ length: this.totalPages }, (_, i) => i);
    // }

   

    updateTotalClients(): void {
        // Select all elements with class 'client-content' that are projected or in the template
        const clients = this.elementRef.nativeElement.querySelectorAll('.client-content');
        this.totalClients = clients.length;
        console.log('Total clients found:', this.totalClients);

        // Manually trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError
        // because we are updating a property bound in the template (pages) after the check
        this.cdr.detectChanges();
    }

    // Calculate total pages dynamically
    get totalPages(): number {
        return Math.ceil(this.totalClients / this.itemsPerPage);
    }

    // Method to change the current page
    goToPage(pageIndex: number): void {
        console.log('Going to page:', pageIndex);
        this.currentPage = pageIndex;
    }

    // Method to check if a client should be visible
    isVisible(index: number): boolean {
        const startIndex = this.currentPage * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        const visible = index >= startIndex && index < endIndex;
        return visible;
    }

    // Generate array for pagination dots
    get pages(): number[] {
        return Array.from({ length: this.totalPages }, (_, i) => i);
    }

    loadEvents(): void {
      this.galleryService.getEvents().subscribe({
        next: (data) => {
          this.categories = data;
        },
        error: (error) => {
          console.error('Error loading events:', error);
        }
      });
    }
}
